import _ from 'lodash';

const getExtendedInvestorFeatureCodeName = ({ codes, name }) =>
  _.join([..._.values(codes).filter(Boolean), name], ' - ');

export const extendInvestorFeatureCode = (i, { isInternalCompany } = {}) => ({
  ...i,
  extendedName: getExtendedInvestorFeatureCodeName(i),
  ...(_.isBoolean(isInternalCompany) && { isGlobal: !isInternalCompany && i.isGlobal }),
  value: i.id,
});
